import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons, numberToPxOrString, placements, positions } from '@/utils'

import render from './render'

const className = 'badge'

export default {
  name: 'Badge',

  props: {
    value: [ String, Number ],

    tooltip: String,

    icon: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },
    iconColor: {
      type: String,
      default: Colors.white,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    color: {
      type: String,
      default: Colors.info,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },
    position: {
      type: String,
      default: positions.absolute,
      validator: value => {
        return Object.values(positions).includes(value)
      }
    },

    placement: {
      type: Object,
      default: () => {
        return {
          [placements.top]: false,
          [placements.right]: true,
          [placements.bottom]: true,
          [placements.left]: false
        }
      }
    },
    exact: {
      type: Object,
      default: () => {
        return {
          [placements.top]: undefined,
          [placements.right]: undefined,
          [placements.bottom]: undefined,
          [placements.left]: undefined
        }
      }
    },

    offset: {
      type: String,
      default: undefined,
      validator: value => {
        return [ 'in', 'out' ].includes(value)
      }
    },

    size: {
      type: Number,
      default: 16
    },

    rounded: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $_class() {
      const result = [
        className,
        `${className}--${this.color}`,
        `${className}--${this.position}`
      ]

      if (this.position === positions.absolute) {
        Object.keys(this.placement).some(place => {
          if (this.placement[place]) {
            result.push(`${className}--${place}`)
          }
        })

        if (this.offset) {
          result.push(`${className}--offset-${this.offset}`)
        }
      }

      return result
    },

    $_size() {
      const result = {}
      const properties = [ 'minHeight', 'maxHeight', 'height', 'maxWidth', 'minWidth', 'width' ]
      for (const property of properties) {
        result[property] = numberToPxOrString(this.size)
      }

      return result
    },

    $_exact() {
      const result = {}

      if (this.position === positions.absolute) {
        for (const key of Object.keys(this.exact)) {
          if (this.exact[key] !== undefined) {
            result[key] = numberToPxOrString(this.exact[key])
          }
        }
      }

      return result
    },

    $_style() {
      const result = {
        ...this.$_size,
        ...this.$_exact
      }

      if (this.rounded) {
        result.borderRadius = numberToPxOrString(this.size / 4)
      }

      return result
    },

    $_directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: {
            value: this.tooltip,
            placement: placements.top
          }
        })
      }

      return result
    }
  },

  render
}
